/* Bóveda: lo que comparten «Arma tu regalo» y el carrito. Lee los regalos desde las propiedades de cada línea. */
(function () {
  if (window.BNRegalo) return;
  var EMPAQUES = {
    caja: { id: 44871707590864, nombre: 'Caja de regalo', en: 'En caja', txt: 'caja' },
    bolsa: { id: 44871707656400, nombre: 'Bolsa de regalo', en: 'En bolsa', txt: 'bolsa' }
  };
  var TARJETAS = ['Navidad', 'Felices Fiestas', 'Día de la Madre', 'Cumpleaños', 'Vibra y Brilla Bonito', 'Florecer desde Adentro', 'Sin tarjeta'];
  var POR_ELEGIR = 'Por elegir';
  function money(c) { return '$' + (Number(c || 0) / 100).toFixed(2); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }
  function leer() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      return r.json();
    });
  }
  /* crudo: sin pasar por el aviso del cajón, que se abriría encima de la pantalla al agregar. */
  function post(url, body, crudo) {
    return (crudo && window.bnFetchCrudo ? window.bnFetchCrudo : fetch)(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) {
        if (!r.ok || d.status) { var e = new Error(d.description || d.message || 'cart'); e.datos = d; throw e; }
        return d;
      });
    });
  }
  function props(i) { return i.properties || {}; }
  function tipoDe(regalo) { return /bolsa/i.test(regalo || '') ? 'bolsa' : 'caja'; }
  function cadenaCoincide(con, linea) {
    return window.bnChainMatches ? window.bnChainMatches(con, linea) : false;
  }
  /* Convierte el carrito en regalos: cada uno con su empaque y sus filas. Dije + cadena es una sola fila. */
  function regalos(cart) {
    var grupos = {}, orden = [];
    ((cart && cart.items) || []).forEach(function (i) {
      var p = props(i), id = p._regalo_id;
      if (!id) return;
      if (!grupos[id]) {
        grupos[id] = { id: id, num: parseInt(p._regalo_num, 10) || 0, regalo: p.Regalo || '', tipo: tipoDe(p.Regalo), empaques: [], productos: [], filas: [] };
        orden.push(grupos[id]);
      }
      if (p._regalo_empaque) grupos[id].empaques.push(i); else grupos[id].productos.push(i);
    });
    orden.forEach(function (g) {
      var usadas = [];
      g.productos.forEach(function (d) {
        var con = props(d).Con;
        if (!con) return;
        var ch = g.productos.filter(function (c) {
          return usadas.indexOf(c) < 0 && props(c)['Para el dije'] === d.product_title && cadenaCoincide(con, c);
        })[0];
        if (ch) usadas.push(ch);
        g.filas.push({ clave: d.variant_id + '|' + con, linea: d, cadena: ch || null, con: con });
      });
      g.productos.forEach(function (i) {
        if (props(i).Con || usadas.indexOf(i) > -1) return;
        g.filas.push({ clave: i.variant_id + '|' + (props(i)['Para el dije'] || ''), linea: i, cadena: null, con: '' });
      });
      g.filas.forEach(function (f) {
        f.cantidad = f.linea.quantity;
        f.total = f.linea.final_line_price + (f.cadena ? f.cadena.final_line_price : 0);
        f.original = f.linea.original_line_price + (f.cadena ? f.cadena.original_line_price : 0);
      });
      var e = g.empaques[0];
      g.empaque = e || null;
      if (e) {
        g.tipo = e.variant_id === EMPAQUES.bolsa.id ? 'bolsa' : e.variant_id === EMPAQUES.caja.id ? 'caja' : g.tipo;
        g.tarjeta = props(e).Tarjeta || '';
      }
      g.cantidad = g.filas.reduce(function (s, f) { return s + f.cantidad; }, 0);
      g.total = g.filas.reduce(function (s, f) { return s + f.total; }, 0) +
        g.empaques.reduce(function (s, x) { return s + x.final_line_price; }, 0);
    });
    /* Número a mostrar: el guardado (no se renumera al borrar un regalo) si todos son distintos; si se repiten, por posición. */
    var vistos = {}, distintos = orden.every(function (g) { if (!g.num || vistos[g.num]) return false; vistos[g.num] = true; return true; });
    if (distintos) orden.sort(function (a, b) { return a.num - b.num; });
    orden.forEach(function (g, i) { g.ver = distintos ? g.num : i + 1; });
    return orden;
  }
  function mayorNumero(cart) {
    return regalos(cart).reduce(function (m, g) { return Math.max(m, g.num); }, 0);
  }
  /* Deja el carrito exactamente como estaba: Shopify, al quedarse sin unidades, puede bajar o borrar otra línea del mismo producto. */
  function restaurar(antes) {
    return leer().then(function (ahora) {
      var previo = {}, u = {}, hay = false, vistas = {}, adds = [];
      antes.items.forEach(function (l) { previo[l.key] = l; });
      ahora.items.forEach(function (l) {
        vistas[l.key] = true;
        var q = previo[l.key] ? previo[l.key].quantity : 0;
        if (q !== l.quantity) { u[l.key] = q; hay = true; }
      });
      antes.items.forEach(function (l) {
        if (!vistas[l.key]) adds.push({ id: l.variant_id, quantity: l.quantity, properties: props(l) });
      });
      return (hay ? post('/cart/update.js', { updates: u }) : Promise.resolve()).then(function () {
        return adds.length ? post('/cart/add.js', { items: adds }, true) : null;
      });
    });
  }
  /* true si cambió alguna línea que no se pidió tocar. */
  function otrasCambiaron(antes, ahora, tocadas) {
    var q = {};
    ahora.items.forEach(function (l) { q[l.key] = l.quantity; });
    return antes.items.some(function (l) { return !tocadas(l) && q[l.key] !== l.quantity; });
  }
  function grupoDe(cart, id) { return regalos(cart).filter(function (x) { return x.id === id; })[0] || null; }
  function filaDe(g, clave) { return g ? g.filas.filter(function (x) { return x.clave === clave; })[0] || null : null; }
  /* Lo que se muestra debajo del nombre: la cadena del dije o la variante. */
  function opcionFila(f) {
    var l = f.linea;
    if (f.con) return 'Con ' + f.con.charAt(0).toLowerCase() + f.con.slice(1);
    return l.variant_title && l.variant_title !== 'Default Title' ? l.variant_title : '';
  }
  /* Si la tienda limita un dije o su cadena por inventario, los dos quedan en la misma cantidad. */
  function emparejar(id, cart) {
    var g = grupoDe(cart, id), updates = {}, hay = false;
    if (!g) return Promise.resolve(null);
    g.filas.forEach(function (f) {
      if (f.cadena && f.cadena.quantity !== f.linea.quantity) {
        var q = Math.min(f.cadena.quantity, f.linea.quantity);
        updates[f.linea.key] = q; updates[f.cadena.key] = q; hay = true;
      }
    });
    return hay ? post('/cart/update.js', { updates: updates }) : Promise.resolve(null);
  }
  /* Qué pedir para dejar una fila en q: dije y cadena van juntos, y sin productos se va también el empaque. */
  function updatesFila(g, clave, q) {
    var f = filaDe(g, clave);
    if (!f) return null;
    var u = {};
    u[f.linea.key] = q;
    if (f.cadena) u[f.cadena.key] = q;
    if (q === 0 && g.filas.length === 1) g.empaques.forEach(function (e) { u[e.key] = 0; });
    if (q > f.cantidad) u._sube = true;
    return u;
  }
  /* La clave de una línea puede cambiar entre pedidos: se busca de nuevo por variante y propiedades. */
  function subir(cart, updates) {
    var porKey = {};
    cart.items.forEach(function (l) { porKey[l.key] = l; });
    return Object.keys(updates).reduce(function (p, k) {
      return p.then(function (actual) {
        var o = porKey[k], huella = o && JSON.stringify(props(o));
        var l = o && actual.items.filter(function (x) { return x.variant_id === o.variant_id && JSON.stringify(props(x)) === huella; })[0];
        if (!l) return actual;
        return post('/cart/change.js', { id: l.key, quantity: updates[k] }).catch(leer);
      });
    }, Promise.resolve(cart));
  }
  /* Toda acción vuelve a leer el carrito antes y después. Subir cantidad va por change.js: update.js no respeta el inventario. Si faltan unidades, change.js responde error pero aplica un tope, y puede bajar otra línea del mismo producto: se revisa siempre. Responde { cart, restaurado }. */
  function aplicar(id, accion) {
    return leer().then(function (cart) {
      var g = grupoDe(cart, id), updates = g && accion(g);
      if (!updates) return { cart: cart };
      var envio;
      if (updates._sube) {
        delete updates._sube;
        envio = subir(cart, updates);
      } else envio = post('/cart/update.js', { updates: updates }).catch(function () { return null; });
      return envio.then(leer).then(function (despues) {
        var otra = otrasCambiaron(cart, despues, function (l) { return updates[l.key] !== undefined; });
        if (otra) return restaurar(cart).then(leer).then(function (c) { return { cart: c, restaurado: true }; });
        return emparejar(id, despues).then(function (r) { return r ? leer() : despues; }).then(function (c) { return { cart: c }; });
      });
    });
  }
  function cambiarFila(id, clave, q) {
    return aplicar(id, function (g) { return updatesFila(g, clave, q); });
  }
  /* «Hacer otro igual»: un regalo nuevo con las mismas líneas, en un solo pedido. Va crudo: el modo regalo no debe reescribir sus propiedades y el cajón no debe abrirse. Si no entra completo, el carrito queda como estaba. */
  function duplicar(id) {
    var ya = window.__bnRegaloOcupado, soltar = function () { if (!ya) window.__bnRegaloOcupado = false; };
    window.__bnRegaloOcupado = true;
    return leer().then(function (cart) {
      var g = grupoDe(cart, id);
      if (!g) throw new Error('regalo');
      var nuevo = nuevoId(), num = mayorNumero(cart) + 1, fuente = g.productos.concat(g.empaques);
      var items = fuente.map(function (l) {
        var o = props(l), p = {}, k;
        for (k in o) if (o[k] != null) p[k] = o[k];
        p.Regalo = num + ' en ' + g.tipo; p._regalo_id = nuevo; p._regalo_num = String(num);
        var i = { id: l.variant_id, quantity: l.quantity, properties: p };
        if (l.selling_plan_allocation) i.selling_plan = l.selling_plan_allocation.selling_plan.id;
        return i;
      });
      var fallo = null;
      return post('/cart/add.js', { items: items }, true).catch(function (e) { fallo = e; }).then(leer).then(function (ahora) {
        var copia = ahora.items.filter(function (l) { return props(l)._regalo_id === nuevo; });
        var completa = copia.length === fuente.length && fuente.every(function (l) {
          return copia.some(function (c) {
            return c.variant_id === l.variant_id && c.quantity === l.quantity && props(c).Con === props(l).Con && props(c)['Para el dije'] === props(l)['Para el dije'] && props(c)._regalo_empaque === props(l)._regalo_empaque;
          });
        }) && !otrasCambiaron(cart, ahora, function () { return false; });
        if (completa) return { cart: ahora, id: nuevo, ver: grupoDe(ahora, nuevo).ver };
        return restaurar(cart).then(function () {
          var e = new Error('incompleto');
          e.limite = !fallo || !!fallo.datos;
          throw e;
        });
      });
    }).then(function (res) { soltar(); refrescarCajon(); return res; }, function (e) { soltar(); refrescarCajon(); throw e; });
  }
  /* El cajón se refresca al ver un cambio de carrito por fetch; un pedido vacío no toca nada y no lo abre. */
  function refrescarCajon() { post('/cart/update.js', { updates: {} }).catch(function () {}); }
  /* Cambia la tarjeta en la línea del empaque, conservando todas sus propiedades. */
  function ponerTarjeta(empaque, nombre) {
    var p = {}, k, o = props(empaque);
    for (k in o) p[k] = o[k];
    p.Tarjeta = nombre;
    return post('/cart/change.js', { id: empaque.key, quantity: 1, properties: p });
  }
  function nuevoId() {
    return 'r' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
  }
  window.BNRegalo = { EMPAQUES: EMPAQUES, TARJETAS: TARJETAS, POR_ELEGIR: POR_ELEGIR, ponerTarjeta: ponerTarjeta, money: money, esc: esc, leer: leer, post: post, props: props, tipoDe: tipoDe, regalos: regalos, mayorNumero: mayorNumero, restaurar: restaurar, otrasCambiaron: otrasCambiaron, nuevoId: nuevoId, grupoDe: grupoDe, filaDe: filaDe, opcionFila: opcionFila, updatesFila: updatesFila, aplicar: aplicar, cambiarFila: cambiarFila, duplicar: duplicar, refrescarCajon: refrescarCajon };
})();
